import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SubMenu from '../Menu/SubMenu';
import MenuItemDetail from '../Menu/MenuItemDetail';
import { MenuType } from '../../constant';
import ProductAuth from '../ProductAuth';
const MenuItem = (props) => {
    const { menuItem, os, platform, lastItem = false, authFunctions } = props;
    const { type } = menuItem;
    const showAuth = menuItem.showAuth;
    const onLogin = menuItem.showAuth === 'AI'
        ? authFunctions.onAILogin
        : authFunctions.onStudioLogin;
    const onSignUp = menuItem.showAuth === 'AI'
        ? authFunctions.onAISignUp
        : authFunctions.onStudioSignUp;
    const loginText = menuItem.showAuth === 'AI' ? 'AI login' : 'Studio login';
    const signUpText = menuItem.showAuth === 'AI' ? 'AI sign up' : 'Studio sign up';
    return (_jsx(React.Fragment, { children: (type === MenuType.LEAF && (_jsx(MenuItemDetail, { lastItem: lastItem, menuItem: props.menuItem, heading: false }))) || (_jsxs(React.Fragment, { children: [_jsx(MenuItemDetail, { lastItem: lastItem, menuItem: props.menuItem, heading: true }), showAuth ? (_jsx(ProductAuth, { onLogin: onLogin, onSignUp: onSignUp, loginText: loginText, signUpText: signUpText })) : (_jsx(_Fragment, {})), _jsx(SubMenu, { os: os, platform: platform, subMenu: props.menuItem, authFunctions: authFunctions })] })) }));
};
export default MenuItem;
